import { m } from '@aimfora/i18n'
import { createFileRoute, Link } from '@tanstack/react-router'
import { PageHeader } from '~/components/app-shell'
import { ExamCreate } from '~/components/exam-create'

export const Route = createFileRoute('/_authed/app/exams/new')({
  head: () => ({ meta: [{ title: `${m.exam_new_title()} – ${m.app_name()}` }] }),
  component: NewExamPage,
})

function NewExamPage() {
  return (
    <>
      <Link
        to="/app"
        className="text-ink-soft text-sm underline-offset-2 hover:text-ink hover:underline"
      >
        ← {m.exam_back()}
      </Link>
      <div className="mt-2">
        <PageHeader title={m.exam_new_title()} />
      </div>
      <ExamCreate />
    </>
  )
}
